module.exports = __webpack_public_path__ + "img/codepen.da2ec3e9.svg";